"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.warn = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var logShown = {};

var shouldLog = function shouldLog(key) {
  return !_enviro.default.deployed() && (key == null || !logShown[key]);
};

var markAsShown = function markAsShown(key) {
  if (key) {
    logShown[key] = true;
  }
};

var warn = function warn(_ref) {
  var _ref$message = _ref.message,
      message = _ref$message === void 0 ? '' : _ref$message,
      key = _ref.key,
      url = _ref.url;

  if (url) {
    message += "\nFor details, see: " + url;
  }

  if (shouldLog(key)) {
    console.warn(message);
    markAsShown(key);
  }
};

exports.warn = warn;
var _default = {
  warn: warn
};
exports.default = _default;